import { render, staticRenderFns } from "./CableBrand.vue?vue&type=template&id=7189e5fc&scoped=true&"
import script from "./CableBrand.vue?vue&type=script&lang=js&"
export * from "./CableBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7189e5fc",
  null
  
)

export default component.exports